import { V3Models } from "@istari/istari-client";

import { ConnectionShare } from "~/secure-connections/model/connection-share";

type RemoteFileShareDto = V3Models.RemoteFileShareDto;

export function toConnectionShare(dto: RemoteFileShareDto): ConnectionShare {
  return {
    id: dto.id,
    sendingConnectionId: dto.sendingConnectionId,
    fileId: dto.fileId,
    editAccess: toEditAccess(dto.shareLevel),
    created: dto.created,
    isArchived: dto.isArchived,
    archived: dto.archived,
  };
}

function toEditAccess(level: RemoteFileShareDto["shareLevel"]): ConnectionShare["editAccess"] {
  switch (level) {
    case "Editor":
      return "editor";
    case "Viewer":
      return "viewer";
    default: {
      const exhaustive: never = level;
      return exhaustive;
    }
  }
}
